import type { FC } from 'react'

import useUser from '@/hooks/user'

import { Orders } from './Orders'

export const TradeIn: FC = () => {
  const user = useUser()
  const customerId = user?.customerId

  if (!customerId) throw Error('Customer id is missing!')

  return <Orders customerId={customerId} />
}
